import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faUserPlus, faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import axios from 'axios';
import { API } from '../API/api';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import AlertBar from '../Components/AlertBar';
import { createTheme } from '@mui/material/styles';
import { ThemeProvider } from '@mui/material/styles';
import { Checkbox, DialogActions, FormControlLabel } from '@mui/material';
import TokenExpired from '../Components/TokenExpired';
import { useAuth } from '../Context/AuthContext';
import NotAuthorized from './NotAuthorized';
import { useNavigate } from 'react-router-dom';
import ButtonAttribute from '../Components/ButtonAttribute';
const theme = createTheme({
  typography: {
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    h3: {
      fontWeight: 700,
      letterSpacing: '-0.025em'
    },
    h4: {
      fontWeight: 600,
      letterSpacing: '-0.025em'
    },
    body1: {
      fontWeight: 500
    }
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#3b82f6',
      light: '#8b9eff',
      dark: '#2563eb'
    },
    secondary: {
      main: '#8b5cf6',
      light: '#a78bfa',
      dark: '#7c3aed'
    },
    background: {
      default: '#f8fafc',
      paper: '#ffffff'
    },
    text: {
      primary: '#1f2937',
      secondary: '#6b7280'
    }
  },
  shape: {
    borderRadius: 8
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 8,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
          }
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
        }
      }
    }
  }
});

const UserManagement = () => {
  const [Info, setInfo] = useState([]);
  const [token, setToken] = useState('');
  const [isLoadingRole, setIsLoadingRole] = useState(true);
  const [alertOpenNotModiferUser, setAlertOpenNotModiferUser] = useState(false);
  const handleAlertOpenNotModiferUser = () => {
    setAlertOpenNotModiferUser(true);
  };
  const handleAlertCloseNotModiferUser = () => {
    setAlertOpenNotModiferUser(false);
  };

  const [alertOpenUpdatedUser, setAlertOpenUpdatedUser] = useState(false);
  const handleAlertOpenUpdatedUser = () => {
    setAlertOpenUpdatedUser(true);
  };
  const handleAlertCloseUpdatedUser = () => {
    setAlertOpenUpdatedUser(false);
  };

  const [alertOpenAddUser, setAlertOpenAddUser] = useState(false);
  const handleAlertOpenAddUser = () => {
    setAlertOpenAddUser(true);
  };
  const handleAlertCloseAddUser = () => {
    setAlertOpenAddUser(false);
  };
  const [alertOpenNotCompleteInfoUser, setAlertOpenNotCompleteInfoUser] = useState(false);
  const handleAlertOpenNotCompleteInfoUser = () => {
    setAlertOpenNotCompleteInfoUser(true);
  }
  const handleAlertCloseNotCompleteInfoUser = () => {
    setAlertOpenNotCompleteInfoUser(false);
  }

  const [alertOpenDeleteUser, setAlertOpenDeleteUser] = useState(false);
  const handleAlertOpenDeleteUser = () => {
    setAlertOpenDeleteUser(true);
  }
  const handleAlertCloseDeleteUser = () => {
    setAlertOpenDeleteUser(false);
  }
  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [newUser, setNewUser] = useState({
    name: '',
    email: '',
    email_verified_at: new Date().toISOString(),
    password: '',
    role_id: '2',
    permissions: [

    ],
  });

  const [userEdit, setUserEdit] = useState({
    id: '',
    name: '',
    email: '',
    role_id: '',
    password: '',
    permissions: [],
  });

  const [updateUser, setUpdateUser] = useState({
    id: '',
    name: '',
    email: '',
    role_id: '',
    password: '',
    permissions: [],
  });
  const [errors, setErrors] = useState({
    error: false,
    message: '',
  })
  const permissionOptions = {
    dashboard: [
      "tableau de bord",
      "Aide decision"
    ],
    tarifications: [
      "ajouter tarification",
      "modifier tarification",
      "supprimer tarification",
      "exporter tarification",
      "importer tarification",
      "list tarification",
    ],
    voyages: [
      "ajouter voyage",
      "modifier voyage",
      "supprimer voyage",
      "list voyage",
      "importer voyage",
      "exporter voyage",
      "confirmer voyage",
      "annuler voyage",
    ],
    Chauffeurs: [
      "ajouter Chauffeur",
      "modifier Chauffeur",
      "supprimer Chauffeur",
      "exporter Chauffeur",
      "importer Chauffeur",
      "list chauffeur",
    ],
    Vehicules: [
      "ajouter vehicule",
      "modifier vehicule",
      "supprimer vehicule",
      "importer vehicule",
      "exporter vehicule",
      "list vehicule",
    ],
    Clients: [
      "ajouter Client",
      "modifier Client",
      "supprimer Client",
      "exporter Client",
      "importer Client",
      "list client",
    ],
    Carburants: [
      "ajouter Carburant",
      "modifier Carburant",
      "supprimer Carburant",
      "exporter Carburant",
      "importer Carburant",
      "list carburant",
    ],
    Interlocuteurs: [
      "ajouter Interlocuteur",
      "modifier Interlocuteur",
      "supprimer Interlocuteur",
    ],
    Logistique: [
      "ajouter Scelle",
      "modifier Scelle",
      "supprimer Scelle",
      "exporter Scelle",
      "importer Scelle",
      "list scelle",
    ],
    Documents: [
      "ajouter Document",
      "modifier Document",
      "supprimer Document",
      "exporter Document",
      "importer Document",
      "list document",
      "gerer rappels document",
      "voir alertes document",
      "gerer types document",
      "voir statistiques document",
    ]
  };
  const [openDelete, setOpenDelete] = useState(false);
  const handleCloseDelete = () => setOpenDelete(false);
  const handleOpenDelete = (id) => {
    setOpenDelete(true)
    setIdDelete(id);
  }
  const [idDelete, setIdDelete] = useState('');
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const [role, setRole] = useState('');
  const navigate = useNavigate();
  useEffect(() => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');

    if (!storedAuthState) {
      setIsLoadingRole(false);
      return;
    }

    const parsedAuthState = JSON.parse(storedAuthState);

    setToken(parsedAuthState?.token || "");
    setRole(parsedAuthState?.role || "");

    if (parsedAuthState?.token) {
      if ([1, 3].includes(parsedAuthState.role)) {
        fetchUsers(parsedAuthState.token);
      } else {
        navigate('/NotAuthorized');
      }
    }

    setIsLoadingRole(false); // ✅ VERY IMPORTANT
  }, []);
  const handleAddUser = () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState);

    if (parsedAuthState?.token) {
      if (newUser.name && newUser.email && newUser.role_id && newUser.password) {
        axios
          .post(`${API}/users`, newUser, {
            headers: {
              Authorization: `Bearer ${parsedAuthState.token}`,
            },
          })
          .then((res) => {
            handleAddPermissions(parsedAuthState.token, res.data.data.id);
            setOpen(false);
            setNewUser({
              name: '',
              email: '',
              email_verified_at: true,
              role_id: '2',
              password: '',
              permissions: [],
            });
            handleAlertOpenAddUser();
            fetchUsers(parsedAuthState.token);
          })
          .catch((err) => {
            setErrors({ error: true, message: err.response.data.message });
          });
      } else {
        handleAlertOpenNotCompleteInfoUser();
      }
    }
  };


  const handleAddPermissions = (token, id) => {
    // Send the transformed permissions array to the API
    axios
      .post(
        `${API}/permissions/create/${id}`,
        {
          user_id: id,
          permissions: newUser.permissions, // Send the transformed permissions array
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
      })
      .catch((err) => {
        console.error("Error adding permissions:", err);

      });
  };

  const handleUpdateUser = () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState);

    if (parsedAuthState?.token) {
      // Check if any user details have changed
      if (
        updateUser.name === userEdit.name &&
        updateUser.email === userEdit.email &&
        updateUser.role_id === userEdit.role_id &&
        updateUser.password === '' &&
        JSON.stringify(updateUser.permissions) === JSON.stringify(userEdit.permissions)
      ) {
        handleAlertOpenNotModiferUser();
      } else {
        // Update user details
        axios
          .put(
            `${API}/users/${userEdit.id}`,
            {
              name: userEdit.name,
              email: userEdit.email,
              role_id: userEdit.role_id,
              password: userEdit.password || undefined, // Only send password if it's not empty
            },
            {
              headers: {
                Authorization: `Bearer ${parsedAuthState.token}`,
              },
            }
          )
          .then((res) => {
            // Update user permissions
            return axios.post(
              `${API}/permissions/update`,
              { user_id: userEdit.id, permissions: userEdit.permissions },
              {
                headers: {
                  Authorization: `Bearer ${parsedAuthState.token}`,
                },
              }
            );
          })
          .then((permissionsRes) => {
            // Close the dialog and reset the form
            setOpenEdit(false);
            setUserEdit({
              name: '',
              email: '',
              role_id: '1',
              password: '',
              permissions: [], // Reset permissions as well
            });

            // Show success alert and refresh users list
            handleAlertOpenUpdatedUser();
            fetchUsers(parsedAuthState.token);
          })
          .catch((err) => {
            console.error('Error updating user or permissions:', err);
          });
      }
    }
  };

  const handleDeleteUser = () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState);

    if (parsedAuthState?.token) {
      axios
        .delete(`${API}/users/${idDelete}`, {
          headers: {
            Authorization: `Bearer ${parsedAuthState.token}`,
          },
        })
        .then((res) => {
          handleAlertOpenDeleteUser();
          fetchUsers(parsedAuthState.token);
          handleCloseDelete();
        })
        .catch((err) => {
          console.error('Error deleting user:', err);
        });
    }
  };

  const handleEditUser = async (id) => {
    setOpenEdit(true);
    const userToEdit = Info.find((user) => user.id === id);
    setUserEdit(userToEdit);

    const userPermissions = await fetchPermissions(id);
    setUserEdit({
      id: userToEdit.id,
      name: userToEdit.name,
      email: userToEdit.email,
      role_id: userToEdit.role_id,
      password: '',
      permissions: userPermissions,
    });
    setUpdateUser({
      id: userToEdit.id,
      name: userToEdit.name,
      email: userToEdit.email,
      role_id: userToEdit.role_id,
      password: '',
      permissions: userPermissions,
    });

  };

  const fetchUsers = async (token) => {
    try {
      const response = await axios.get(`${API}/users`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const users = response.data.data; // Assuming this is an array of users
      if (users) {
        setIsLoading(false);
        setInfo(users);
      }

    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  const fetchPermissions = async (userId) => {
    try {
      const storedAuthState = sessionStorage.getItem('authLocalstorage');
      if (!storedAuthState) {
        console.error('No authentication state found in sessionStorage');
        return [];
      }

      const parsedAuthState = JSON.parse(storedAuthState);
      if (!parsedAuthState?.token) {
        console.error('No token found in authentication state');
        return [];
      }

      const token = parsedAuthState.token;
      const response = await axios.get(`${API}/permissions/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data.permissions || []; // Ensure it returns an array
    } catch (error) {
      console.error(`Error fetching permissions for user ${userId}:`, error);
      return [];
    }
  };


  const [isNavbar, setIsNavbar] = useState('');

  return (
    <ThemeProvider theme={theme}>
      {isLoadingRole ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="80vh">
        <CircularProgress />
         </Box>
      ) : role === 1 || role === 3 ? (
        <>
          {token !== "" ?
            <Box
              sx={{
                padding: isNavbar ? { xs: "80px 20px 10px 20px", md: '80px 20px 10px 20px' } : { xs: "80px 20px 10px 20px", md: '40px 20px 10px 50px' },
                width: '100%',
                backgroundColor: '#f8fafc',

                minHeight: '116vh',
                transition: 'all 0.3s ease-in-out',
              }}
            >
              <Box >
                <Box sx={{
                  backgroundColor: '#ffffff',
                  border: '1px solid #e5e7eb4b',
                  borderRadius: '32px',
                  padding: { xs: '20px', md: '30px' },
                  marginBottom: '20px',
                  boxShadow: "0 4px 6px rgba(99, 102, 241, 0.2)",
                }}>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '16px',
                    paddingBottom: '16px',
                    borderBottom: '1px solid #f3f4f6'
                  }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <Box sx={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '6px',
                        backgroundColor: '#3b82f6',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <FontAwesomeIcon icon={faUserPlus} style={{ color: 'white', fontSize: '16px' }} />
                      </Box>
                      <Typography variant="h3" sx={{
                        fontWeight: 600,
                        color: '#1f2937',
                        fontSize: { xs: '1.5rem', md: '1.875rem' },
                        letterSpacing: '-0.025em'
                      }}>
                        Gestion des Utilisateurs
                      </Typography>
                    </Box>

                    <Typography variant="body2" sx={{
                      color: '#6b7280',
                      fontSize: '14px',
                      fontWeight: 500,
                      backgroundColor: '#f9fafb',
                      padding: '6px 12px',
                      borderRadius: '6px',
                      border: '1px solid #e5e7eb'
                    }}>
                      {Info.length} utilisateur{Info.length !== 1 ? 's' : ''}
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <ButtonAttribute
                      type="button"
                      Bgcolor="#3b82f6"
                      color="#ffffff"
                      bgColorHover="#2563eb"
                      ColorHover="#ffffff"
                      startIcon={<FontAwesomeIcon icon={faUserPlus} />}
                      Label="Ajouter un nouvel utilisateur"
                      action={() => setOpen(true)}
                      width="auto"
                      height="48px"

                    />

                  </Box>
                </Box>

                <TableContainer
                  component={Paper}
                  sx={{
                    backgroundColor: '#ffffff',
                    border: '1px solid #e5e7eb4b',
                    borderRadius: '32px',
                    marginBottom: '20px',
                    boxShadow: "0 4px 6px rgba(99, 102, 241, 0.2)",
                  }}
                >
                  {/* Show CircularProgress if loading */}
                  {isLoading && (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent background
                        zIndex: 10, // Ensure it appears above the table
                      }}
                    >
                      <CircularProgress />
                    </Box>
                  )}

                  {/* Table */}
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ width: 300 }}>Utilisateur</TableCell>
                        <TableCell style={{ width: 120 }}>Role</TableCell>
                        <TableCell style={{ width: 120 }}>Status</TableCell>
                        {/* <TableCell>Permissions</TableCell> */}
                        <TableCell style={{ width: 120 }}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {/* Render rows only if not loading and data exists */}
                      {!isLoading && Array.isArray(Info) && Info.length > 0 ? (
                        Info.map((user) => (
                          <TableRow key={user.id}>
                            {/* User Details */}
                            <TableCell>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                <Avatar>{user.name[0]}</Avatar>
                                <Box>
                                  <Typography variant="body1" fontWeight="bold">
                                    {user.id}
                                  </Typography>
                                  <Typography variant="body2">{user.name}</Typography>
                                  <Typography variant="caption">{user.email}</Typography>
                                </Box>
                              </Box>
                            </TableCell>

                            {/* Role */}
                            <TableCell>
                              <Chip
                                size="small"
                                sx={{
                                  backgroundColor:
                                    user.role_id == 3
                                      ? '	#1E90FF' // Super Administrateur — sky blue
                                      : user.role_id == 4
                                        ? '#9e9e9e' // Utilisateur (Factures) — grey
                                        : undefined,
                                  color:
                                    user.role_id == 3 || user.role_id == 4
                                      ? 'white'
                                      : undefined,
                                }}
                                color={
                                  user.role_id == 1
                                    ? 'primary'
                                    : user.role_id == 2
                                      ? 'secondary'
                                      : undefined
                                }
                                label={
                                  user.role_id == 1
                                    ? 'Administrateur'
                                    : user.role_id == 2
                                      ? 'Utilisateur'
                                      : user.role_id == 3
                                        ? 'Super Administrateur'
                                        : user.role_id == 4
                                          ? 'Utilisateur - (Factures)'
                                          : 'Inconnu'
                                }
                              />
                            </TableCell>

                            {/* Status */}
                            <TableCell>
                              <Chip size="small" color={'success'} label={'active'} />
                            </TableCell>



                            {/* Actions */}
                            <TableCell>
                              <Box sx={{ display: 'flex', gap: 1 }}>
                                <IconButton
                                  onClick={() => handleEditUser(user.id)}
                                  size="small"
                                  color="primary"
                                >
                                  <FontAwesomeIcon icon={faPenToSquare} />
                                </IconButton>
                                <IconButton
                                  onClick={() => handleOpenDelete(user.id)}
                                  size="small"
                                  color="error"
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </IconButton>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        // Show message if no data and not loading
                        !isLoading && (
                          <TableRow>
                            <TableCell colSpan={5} align="center">
                              <Typography variant="body1">Aucune donnée disponible</Typography>
                            </TableCell>
                          </TableRow>
                        )
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>

              {/* Add User Modal */}
              <Dialog
                open={open}
                onClose={() => setOpen(false)}
                PaperProps={{
                  sx: {
                    borderRadius: '12px',
                    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
                    minWidth: '500px'
                  }
                }}
              >
                <Box sx={{
                  backgroundColor: '#3b82f6',
                  borderRadius: '12px 12px 0 0',
                  padding: '20px',
                  textAlign: 'center'
                }}>
                  <DialogTitle sx={{
                    color: 'white',
                    fontSize: '20px',
                    fontWeight: 600,
                    fontFamily: 'Inter, sans-serif',
                    letterSpacing: '-0.025em',
                    padding: 0
                  }}>
                    Ajouter un nouvel utilisateur
                  </DialogTitle>
                </Box>
                <DialogContent sx={{ padding: '24px' }}>
                  <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 2, width: { xs: '100%', sm: '100%', md: '100%', lg: '400px', xl: '400px' } }}>
                    {/* Name */}
                    <FormControl>
                      <FormLabel>Nom</FormLabel>
                      <TextField
                        placeholder="Entrez le nom"
                        value={newUser.name}
                        onChange={(e) => setNewUser({ ...newUser, name: e.target.value })}
                      />
                    </FormControl>

                    {/* Email */}
                    <FormControl>
                      <FormLabel>Email</FormLabel>
                      <TextField
                        placeholder="Entrez l'email"
                        value={newUser.email}
                        onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
                      />
                    </FormControl>

                    {/* Password */}
                    <FormControl>
                      <FormLabel>Mot de passe</FormLabel>
                      <TextField
                        type="password"
                        placeholder="Entrez le mot de passe"
                        value={newUser.password}
                        onChange={(e) => setNewUser({ ...newUser, password: e.target.value })}
                      />
                    </FormControl>

                    {/* Role */}
                    <FormControl>
                      <FormLabel>Role</FormLabel>
                      <Select
                        value={newUser.role_id}
                        onChange={(e) => setNewUser({ ...newUser, role_id: e.target.value })}
                      >
                        <MenuItem value="2">Utilisateur</MenuItem>
                        <MenuItem value="4">Utilisateur - (Factures) </MenuItem>
                        <MenuItem value="1">Administrateur</MenuItem>
                        <MenuItem value="3">Super Administrateur</MenuItem>
                      </Select>
                    </FormControl>

                    {/* Permissions */}
                    <FormControl>
                      <FormLabel>Permissions</FormLabel>
                      <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1,
                        maxHeight: 200,
                        overflowY: 'auto',
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px',
                        padding: '8px',
                        backgroundColor: '#fafafa',
                      }}>
                        {Object.keys(permissionOptions).map((resourceName, index) => (
                          <Box key={index}>
                            <Typography variant="subtitle2" fontWeight="bold" sx={{ color: '#333' }}>
                              {resourceName}
                            </Typography>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                              {permissionOptions[resourceName].map((action, idx) => (
                                <FormControlLabel
                                  key={idx}
                                  control={
                                    <Checkbox
                                      checked={
                                        newUser.permissions.find(
                                          (perm) => perm.resource === resourceName && perm.action === action
                                        )?.allowed === 1
                                      }
                                      onChange={(e) => {
                                        setNewUser((prev) => {
                                          // Find the index of the permission we're updating
                                          const permissionIndex = prev.permissions.findIndex(
                                            (perm) => perm.resource === resourceName && perm.action === action
                                          );

                                          // Create a new permissions array
                                          const updatedPermissions = [...prev.permissions];

                                          if (permissionIndex !== -1) {
                                            // If the permission exists, update its 'allowed' value
                                            updatedPermissions[permissionIndex] = {
                                              ...updatedPermissions[permissionIndex],
                                              allowed: e.target.checked ? 1 : 0,
                                            };
                                          } else {
                                            // If the permission doesn't exist, add it to the array
                                            updatedPermissions.push({
                                              resource: resourceName,
                                              action: action,
                                              allowed: e.target.checked ? 1 : 0,
                                            });
                                          }

                                          // Return the updated newUser object
                                          return {
                                            ...prev,
                                            permissions: updatedPermissions,
                                          };
                                        });
                                      }}
                                    />

                                  }
                                  label={<Typography variant="body2" sx={{ fontSize: 12, color: '#555' }}>{action}</Typography>}
                                />
                              ))}
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    </FormControl>

                    {/* Error Message */}
                    <Typography variant="body2" color="error" sx={{ textAlign: 'center', justifyContent: 'center', display: 'flex' }}>
                      {errors.error ? errors.message : ''}
                    </Typography>

                    {/* Buttons */}
                    <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                      <Button onClick={handleAddUser} fullWidth variant="contained" sx={{
                        backgroundColor: "#6366f1",
                        borderRadius: "12px",
                        textTransform: "none",
                        padding: "8px 24px",
                        fontWeight: 600,
                        fontSize: "14px",
                        boxShadow: "0 4px 6px rgba(99, 102, 241, 0.2)",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          transform: "translateY(-2px)",
                          boxShadow: "0 6px 12px rgba(99, 102, 241, 0.3)",
                        },
                      }}>
                        {newUser.id ? 'Save Changes' : 'Ajouter un nouvel utilisateur'}
                      </Button>
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => setOpen(false)}
                        fullWidth
                        sx={{
                          borderRadius: "12px",
                          textTransform: "none",
                          padding: "8px 24px",
                          fontWeight: 600,
                          fontSize: "14px",
                          boxShadow: "0 4px 6px rgba(99, 102, 241, 0.2)",
                          transition: "all 0.3s ease",
                          "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0 6px 12px rgba(99, 102, 241, 0.3)",
                          },
                        }}
                      >
                        Cancel
                      </Button>
                    </Box>
                  </Box>
                </DialogContent>
              </Dialog>

              {/* Edit User Modal */}
              <Dialog
                open={openEdit}
                onClose={() => setOpenEdit(false)}
                PaperProps={{
                  sx: {
                    borderRadius: '12px',
                    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
                    minWidth: '500px'
                  }
                }}
              >
                <Box sx={{
                  backgroundColor: '#f59e0b',
                  borderRadius: '12px 12px 0 0',
                  padding: '20px',
                  textAlign: 'center'
                }}>
                  <DialogTitle sx={{
                    color: 'white',
                    fontSize: '20px',
                    fontWeight: 600,
                    fontFamily: 'Inter, sans-serif',
                    letterSpacing: '-0.025em',
                    padding: 0
                  }}>
                    Modifier un utilisateur : {userEdit.id}
                  </DialogTitle>
                </Box>
                <DialogContent sx={{ padding: '24px' }}>
                  <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 2, width: { xs: '100%', sm: '100%', md: '100%', lg: '400px', xl: '400px' } }}>
                    {/* Nom Field */}
                    <FormControl>
                      <FormLabel>Nom</FormLabel>
                      <TextField
                        placeholder="Entrez le nom"
                        value={userEdit.name}
                        onChange={(e) => setUserEdit({ ...userEdit, name: e.target.value })}
                      />
                    </FormControl>

                    {/* Email Field */}
                    <FormControl>
                      <FormLabel>Email</FormLabel>
                      <TextField
                        placeholder="Entrez l'email"
                        value={userEdit.email}
                        onChange={(e) => setUserEdit({ ...userEdit, email: e.target.value })}
                      />
                    </FormControl>

                    {/* Password Field */}
                    <FormControl>
                      <FormLabel>Nouveau mot de passe</FormLabel>
                      <TextField
                        type="password"
                        placeholder="Entrez le mot de passe"
                        value={userEdit.password}
                        onChange={(e) => setUserEdit({ ...userEdit, password: e.target.value })}
                      />
                    </FormControl>

                    {/* Role Field */}
                    <FormControl>
                      <FormLabel>Role</FormLabel>
                      <Select
                        value={String(userEdit.role_id)}
                        onChange={(e) => setUserEdit({ ...userEdit, role_id: e.target.value })}
                      >
                        <MenuItem value="3">Super Administrateur</MenuItem>
                        <MenuItem value="1">Administrateur</MenuItem>
                        <MenuItem value="2">Utilisateur</MenuItem>
                        <MenuItem value="4">Utilisateur - (Factures)</MenuItem>
                      </Select>
                    </FormControl>

                    {/* Permissions Section */}
                    <FormControl>
                      <FormLabel>Permissions</FormLabel>
                      <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 1, overflowY: 'auto', maxHeight: '200px' }}>
                        {userEdit.permissions &&
                          userEdit.permissions.length > 0 &&
                          userEdit.permissions.map((resource, index) => (
                            <Box key={index} sx={{ marginBottom: 1 }}>
                              <Typography variant="subtitle2" fontWeight="bold">
                                {resource.name}
                              </Typography>
                              <Box sx={{ display: 'grid', gap: 0.5 }}>
                                {resource.actions.map((action, idx) => {
                                  // Convert action name to match the frontend format (with spaces)
                                  const actionNameWithSpaces = action.name.replace(/_/g, ' ');

                                  return (
                                    <FormControlLabel
                                      key={idx}
                                      control={
                                        <Checkbox
                                          checked={action.allowed == 1} // Determines if the checkbox is checked
                                          onChange={(e) => {
                                            const isChecked = e.target.checked;

                                            // Create a new copy of permissions to ensure immutability
                                            const newPermissions = userEdit.permissions.map((perm, i) => {
                                              if (i === index) {
                                                // Update the specific action's 'allowed' status
                                                return {
                                                  ...perm,
                                                  actions: perm.actions.map((act, j) =>
                                                    j === idx ? { ...act, allowed: isChecked ? 1 : 0 } : act
                                                  ),
                                                };
                                              }
                                              return perm;
                                            });

                                            // Update the state with the new permissions
                                            setUserEdit({ ...userEdit, permissions: newPermissions });
                                          }}
                                        />
                                      }
                                      label={actionNameWithSpaces} // Display the action name with spaces
                                    />
                                  );
                                })}
                              </Box>
                            </Box>
                          ))}
                      </Box>
                    </FormControl>

                    {/* Action Buttons */}
                    <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                      <Button
                        onClick={handleUpdateUser}
                        fullWidth
                        variant="contained"
                        sx={{
                          backgroundColor: "#6366f1",
                          borderRadius: "12px",
                          textTransform: "none",
                          padding: "8px 24px",
                          fontWeight: 600,
                          fontSize: "14px",
                          boxShadow: "0 4px 6px rgba(99, 102, 241, 0.2)",
                          transition: "all 0.3s ease",
                          "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0 6px 12px rgba(99, 102, 241, 0.3)",
                          },
                        }}
                      >
                        Modifier l'utilisateur
                      </Button>
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => setOpenEdit(false)}
                        fullWidth
                        sx={{
                          borderRadius: "12px",
                          textTransform: "none",
                          padding: "8px 24px",
                          fontWeight: 600,
                          fontSize: "14px",
                          boxShadow: "0 4px 6px rgba(99, 102, 241, 0.2)",
                          transition: "all 0.3s ease",
                          "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0 6px 12px rgba(99, 102, 241, 0.3)",
                          },
                        }}
                      >
                        Annuler
                      </Button>
                    </Box>
                  </Box>
                </DialogContent>
              </Dialog>

              <Dialog
                open={openDelete}
                onClose={handleCloseDelete}
                PaperProps={{
                  sx: {
                    borderRadius: '12px',
                    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
                    minWidth: '400px'
                  }
                }}
              >
                <Box sx={{
                  backgroundColor: '#ef4444',
                  borderRadius: '12px 12px 0 0',
                  padding: '20px',
                  textAlign: 'center'
                }}>
                  <DialogTitle sx={{
                    color: 'white',
                    fontSize: '20px',
                    fontWeight: 600,
                    fontFamily: 'Inter, sans-serif',
                    letterSpacing: '-0.025em',
                    padding: 0
                  }}>
                    Suppression d'un utilisateur
                  </DialogTitle>
                </Box>
                <DialogContent sx={{ padding: '24px' }}>
                  <Typography variant="body1" sx={{
                    fontSize: '16px',
                    fontFamily: 'Inter, sans-serif',
                    color: '#374151',
                    textAlign: 'center',
                    fontWeight: 500,
                    padding: '20px',
                    backgroundColor: '#f9fafb',
                    borderRadius: '6px',
                    border: '1px solid #e5e7eb'
                  }}>
                    Êtes-vous sûr de vouloir supprimer cet utilisateur ID {idDelete} ?
                  </Typography>
                </DialogContent>
                <DialogActions sx={{ padding: '0 24px 24px 24px', gap: '12px' }}>
                  <Button
                    onClick={handleCloseDelete}
                    variant="contained"
                    sx={{
                      backgroundColor: '#6b7280',
                      color: 'white',
                      borderRadius: '6px',
                      fontWeight: 500,
                      fontSize: '14px',
                      textTransform: 'none',
                      padding: '10px 20px',
                      '&:hover': {
                        backgroundColor: '#4b5563'
                      }
                    }}
                  >
                    Annuler
                  </Button>
                  <Button
                    onClick={() => handleDeleteUser()}
                    variant="contained"
                    sx={{
                      backgroundColor: '#ef4444',
                      color: 'white',
                      borderRadius: '6px',
                      fontWeight: 500,
                      fontSize: '14px',
                      textTransform: 'none',
                      padding: '10px 20px',
                      '&:hover': {
                        backgroundColor: '#dc2626'
                      }
                    }}
                  >
                    Supprimer
                  </Button>
                </DialogActions>
              </Dialog>
            </Box> : <TokenExpired />
          }

          {/* Alerts */}
          <AlertBar
            open={alertOpenAddUser}
            onClose={handleAlertCloseAddUser}
            textContent="L'utilisateur a été ajouté avec succès."
            alertColor="success"
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          />
          <AlertBar
            open={alertOpenNotModiferUser}
            onClose={handleAlertCloseNotModiferUser}
            textContent="Aucune des informations n'a été modifiée, donc je ne vais pas effectuer l'opération."
            alertColor="info"
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          />
          <AlertBar
            open={alertOpenUpdatedUser}
            onClose={handleAlertCloseUpdatedUser}
            textContent="Utilisateur mis à jour avec succès"
            alertColor="success"
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          />
          <AlertBar
            open={alertOpenNotCompleteInfoUser}
            onClose={handleAlertCloseNotCompleteInfoUser}
            textContent="Veuillez fournir toutes les informations requises."
            alertColor="info"
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          />
          <AlertBar
            open={alertOpenDeleteUser}
            onClose={handleAlertCloseDeleteUser}
            textContent="Utilisateur supprimé avec succès"
            alertColor="success"
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          />
        </>) : (
        <NotAuthorized />
      )}
    </ThemeProvider>
  );
};

export default UserManagement;